import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _reverseInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reverse';
import React__default from 'react';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';

var _excluded = ["reverse", "justify", "align", "wrap", "children", "className"],
    _excluded2 = ["reverse", "justify", "align", "wrap", "children", "className"];

/**
 * @experimental
 *
 * `Row`和`Col`用于flex布局， 边距css类如 mx-12 mr-24 pt-24 目前只在这里生效
 */
var Row = /*#__PURE__*/React__default.forwardRef(function Row(_ref, ref) {
  var _ref$reverse = _reverseInstanceProperty(_ref),
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      justify = _ref.justify,
      align = _ref.align,
      wrap = _ref.wrap,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: clsx('smb-r', reverse && 'smb-r--reverse', wrap && 'flex-wrap', justify && "justify-".concat(justify), align && "align-".concat(align), className)
  }, rest, {
    ref: ref
  }), children);
});
/**
 * @experimental
 */

var Col = /*#__PURE__*/React__default.forwardRef(function Row(_ref2, ref) {
  var _ref2$reverse = _reverseInstanceProperty(_ref2),
      reverse = _ref2$reverse === void 0 ? false : _ref2$reverse,
      justify = _ref2.justify,
      align = _ref2.align,
      wrap = _ref2.wrap,
      children = _ref2.children,
      className = _ref2.className,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: clsx('smb-c', reverse && 'smb-c--reverse', wrap && 'flex-wrap', justify && "justify-".concat(justify), align && "align-".concat(align), className)
  }, rest, {
    ref: ref
  }), children);
});
var Grid = {
  Row: Row,
  Col: Col
};

export default Grid;
